// Central constants used across the site
export const WHATSAPP_URL = "https://wa.me/34643833854";
export const JOTFORM_URL = "https://form.jotform.com/aprendeingles/registro-formulario";
export const TRIAL_URL = "https://form.jotform.com/aprendeingles/prueba-activeenglish-gratis-durante";
export const CONTACT_EMAIL = "cursos@activeenglish.es";
export const EMAIL_COMPOSE_URL =
  "https://mail.google.com/mail/?view=cm&fs=1&to=cursos@activeenglish.es";

export const TICKER_ITEMS = [
  "Plataforma interactiva 24/7",
  "Tutoría 1:1 con feedback",
  "Certificación al completar nivel",
  "Sin horarios fijos",
  "Plan Regular o Intensivo",
  "Inglés para el mundo real",
  "Beneficios por referidos",
  "Acceso 7 días a la semana",
];

export const NAV_LINKS = [
  { label: "Niveles", href: "#niveles" },
  { label: "Cambridge Exams", href: "#cambridge" },
  { label: "Método", href: "#metodo" },
  { label: "Planes", href: "#planes" },
  { label: "Beneficios", href: "#beneficios" },
  { label: "Contacto", href: "#contacto" },
];

export const IMG = {
  beginner: "/images/beginner.jpg",
  elementary: "/images/elementary.jpg",
  intermediate: "/images/intermediate.jpg",
  advanced: "/images/advanced.jpg",
  studentTablet: "/images/student-tablet.jpg",
  intuitivePlatform: "/images/intuitive-platform.jpg",
  interactiveEval: "/images/interactive-eval.jpg",
  tutoria: "/images/tutoria.jpg",
  studentPlatform: "/images/platform.jpg",
  onlineLearning: "/images/online-learning.jpg",
  studyingCafe: "/images/elementary.jpg",
  campus: "/images/campus.jpg",
  studyingOnline: "/images/studying-online.jpg",
  certification: "/images/certificate.jpg",
  certificateStudent: "/images/certificate.jpg",
  discount: "/images/referral.jpg",
  registrationForm: "/images/registration.jpg",
};

export const HERO_VIDEO = "/assets/hero-video.mp4";
export const HERO_POSTER = IMG.elementary;
